import BaseView from './BaseView';
import { createApp } from 'vue';
import Quiz from '../../vue/Quiz.vue';

let view = null;

class Questionnaire extends BaseView {
	constructor(container) {
		super(container);
		this.el = container.querySelector('[data-questionnaire]');
		this.vueComponent = createApp(
			Quiz,
			JSON.parse(this.el.querySelector('script').textContent)
		);
		this.vueComponent.mount(this.el);
	}

	init() {
        
	}
}

export default {
	namespace: 'template-questionnaire',
	beforeEnter: ({ current, next, trigger }) => {
		view = new Questionnaire(next.container);
		view.init();
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};